'use client';

import React, { ElementType, MouseEventHandler } from 'react';
import { Box, Button, SvgIcon, SxProps, Theme, Typography } from '@mui/material';
import Link from 'next/link';
import { IconSvg } from './Icon';
interface EmptyStateProps {
  desc: string;
  icon?: ElementType;
  iconStyles?: SxProps<Theme>;
  titleBTN?: string;
  href?: string;
  onAction?: MouseEventHandler<HTMLButtonElement>;
}
function EmptyState({
  onAction,
  icon,
  iconStyles,
  href,
  desc,
  titleBTN
}: EmptyStateProps) {
  return <Box sx={{
    width: '100%',
    maxWidth: {
      md: 450,
      xs: 340
    },
    bgcolor: 'background.bg',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    borderRadius: 'var(--corner_radius_m)',
    overflow: 'hidden',
    mx: 'auto',
    py: 'var(--spacing_l_nudge)',
    textAlign: 'center',
    gap: 'var(--spacing_m)',
    flexWrap: 'nowrap'
  }} data-sentry-element="Box" data-sentry-component="EmptyState" data-sentry-source-file="EmptyState.tsx">
      {icon ? <SvgIcon color='inherit' component={icon} sx={{
      ...iconStyles
    }} /> : <IconSvg component={'EmptyState'} width='200' height='200' />}
      <Typography variant='bodyLargeStrong__Wallfund' color='text.text' data-sentry-element="Typography" data-sentry-source-file="EmptyState.tsx">
        {desc}
      </Typography>
      {titleBTN && <Box display='flex' gap={1.5}>
          <Button LinkComponent={Link} variant='contained' color='info' size='large' sx={{
        flex: 1
      }} href={href} onClick={onAction}>
            {titleBTN}
          </Button>
        </Box>}
    </Box>;
}
export default EmptyState;